import React from "react";

import { connect } from "react-redux";

import Select from "./index";

function Entity({ dispatch, config, ...props }) {
  const items = {};
  Object.values(config).forEach((entity) => {
    items[entity.id] = `${entity.id} - ${entity.name}`;
  });

  return <Select name="entity" items={items} {...props} />;
}

const mapStateToProps = (state) => ({
  config: state.prp.config.length ? state.prp.config : state.prp.me.config,
});

export default connect(mapStateToProps)(Entity);
